import { fetchChallengeGroups } from '@actions/challengeGroups/fetchChallengeGroups';
import {
    getChallengeGroups,
    getChallengeGroupsFetchError,
    getChallengeGroupsIsFetching,
} from '@selectors/challengeGroups';
import { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

const useFetchChallengeGroups = () => {
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(fetchChallengeGroups());
    }, [dispatch]);

    const challengeGroupsObj = useSelector(getChallengeGroups);
    const challengeGroups = useMemo(() => {
        const arr = Object.values(challengeGroupsObj);
        return arr.sort((a, b) => a.name.localeCompare(b.name));
    }, [challengeGroupsObj]);
    const isFetching = useSelector(getChallengeGroupsIsFetching);
    const fetchError = useSelector(getChallengeGroupsFetchError);

    return { challengeGroups, isFetching, fetchError };
};

export default useFetchChallengeGroups;
